"use client";
import { useEffect } from "react";
import PropTypes from "prop-types";

import classNames from "classnames";

import Sidebar from "components/map/sidebar";
import ListingMap from "../../listing-map/map";
import MapSwitchButton from "../../listing-search/map-switch-button";

import styles from "./styles.module.css";

const Content = ({
  categoryTree,
  listingCountItems,
  isLandPage,
  screenType,
  isSelectedFilterEmpty,
  handleOrderDropdownChangeWithHistoryPush,
  isLoadingListing,
  isProjectPage,
  newSearchResults,
  getAllListings,
  filters,
  totalListingLength,
}) => {
  const handlePlacemarkClick = (listingItemId) => {
    const currentItem = document.getElementById(`listingItem-${listingItemId}`);
    const itemPosition = currentItem?.offsetTop;
    if (itemPosition ?? true) {
      document.getElementById("scrollableDiv").scrollTop = itemPosition - 120;
    }
  };

  const wrapperClass = classNames({
    [styles.wrapper]: true,
    [styles.isSelectedFilterEmpty]: isSelectedFilterEmpty,
  });

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);

  return (
    <div className={wrapperClass}>
      <div className={styles.sidebarWrap}>
        <Sidebar
          categoryTree={categoryTree}
          listingCountItems={listingCountItems}
          isLandPage={isLandPage}
          screenType={screenType}
          handleOrderDropdownChangeWithHistoryPush={handleOrderDropdownChangeWithHistoryPush}
          isLoadingListing={isLoadingListing}
          isProjectPage={isProjectPage}
          newSearchResults={newSearchResults}
          getAllListings={getAllListings}
          filters={filters}
          totalListingLength={totalListingLength}
        />
      </div>
      <div className={styles.contentWrap}>
        <ListingMap
          handlePlacemarkClick={handlePlacemarkClick}
          getAllListings={getAllListings}
          newSearchResults={newSearchResults}
          isProjectPage={isProjectPage}
        />
        <div className={styles.switchWrap}>
          <MapSwitchButton type="map" url={newSearchResults?.url?.urlForFirstPage} />
        </div>
      </div>
    </div>
  );
};

Content.propTypes = {
  screenType: PropTypes.string,
  categoryTree: PropTypes.array,
  listingCountItems: PropTypes.array,
  isLandPage: PropTypes.bool,
  isSelectedFilterEmpty: PropTypes.bool,
  handleOrderDropdownChangeWithHistoryPush: PropTypes.func,
  isLoadingListing: PropTypes.bool,
  isProjectPage: PropTypes.bool,
  newSearchResults: PropTypes.object,
  getAllListings: PropTypes.func,
  totalListingLength: PropTypes.func,
  filters: PropTypes.object,
};

export default Content;
